const initCartUpsell = () => {
   // console.log("initCartUpsell")
    const swipers = document.querySelectorAll('.cart-upsell .swiper')
    // console.log("swipers", swipers)
    swipers.forEach(el => {
        el.closest(".cart-upsell").classList.remove("invisible")
        const swiper = new Swiper(el, {
            slidesPerView: 2.6,
            spaceBetween: 8,
            grabCursor: true,
            loopAddBlankSlides: true,
            grid: {
                rows: 1,
                fill: 'row',
            }
        })
        // console.log("swiper ", swiper)
    })
}

document.addEventListener("DOMContentLoaded", () => {
    initCartUpsell()
})

function routeMonitor() {
    // Salve a referência ao fetch original
    var originalFetch = window.fetch;

    // Substitua o fetch global por sua própria função
    window.fetch = function (url, options) {
        // verifique se URL é uma string, se não for uma string, retorne o fetch original
        if (typeof url !== 'string') {
            return originalFetch(url, options);
        }
        if (url.includes('?section_id=api-cart-item')) {
            // Se a URL contém '?section_id=api-cart-item', dispare sua função
            console.log('Chamada para ?section_id=api-cart-item encontrada!');
            // Chame sua função aqui
            suaFuncaoQueDeveSerDisparada();
        }

        // Chame o fetch original com os mesmos argumentos
        return originalFetch(url, options);
    };

    function suaFuncaoQueDeveSerDisparada() {
        console.log('suaFuncaoQueDeveSerDisparada() disparada!');
        setTimeout(() => {
            initCartUpsell()
        }, 1000)
    }
}
routeMonitor();